<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2" v-if="loading">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <form
              v-if="!loading"
              @submit.prevent="onSubmit"
              novalidate
              enctype="multipart/form-data"
              :class="
                submitted
                  ? 'needs-validation was-validated'
                  : 'needs-validation'
              "
            >
              <input
                type="hidden"
                name="csrfmiddlewaretoken"
                value="5EWUp9yvYJEVAuMD4cPhiQu5I3rHz0MAEXbAE7KwCW3WeZdJuvDQPm0WHhzr3ZZM"
              />

              <div class="card-text">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="card h-100">
                      <div class="card-body">
                        <h4 class="card-title">General</h4>
                        <p></p>
                        <div class="row">
                          <div class="col-lg-3">
                            <input
                              type="file"
                              ref="file"
                              style="display: none"
                              @change="onFileChange"
                            />
                            <div
                              @click="$refs.file.click()"
                              :class="
                                url
                                  ? 'upload-overlay is-hover'
                                  : 'upload-overlay'
                              "
                            >
                              <img
                                :src="
                                  url
                                    ? url
                                    : '/static/img/blank-img.e73a611.jpeg'
                                "
                                alt=""
                                class="img-fluid w-100"
                              />
                            </div>
                          </div>
                          <div class="col-lg-9">
                            <div class="table-responsive">
                              <table
                                class="
                                  table
                                  align-middle
                                  table-striped table-nowrap
                                  mb-0
                                "
                              >
                                <tbody>
                                  <tr>
                                    <td>Zoom Info ID</td>
                                    <td>
                                      <input
                                        type="text"
                                        name="zoominfo_id"
                                        id="zoominfo_id_id"
                                        class="form-control"
                                        maxlength="255"
                                        v-model="zoominfo_id"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Tax ID</td>

                                    <td>
                                      <input
                                        type="text"
                                        name="tax_id"
                                        id="tax_id_id"
                                        class="form-control"
                                        maxlength="255"
                                        v-model="tax_id"
                                      />
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>DUNS Number</td>

                                    <td>
                                      <input
                                        type="text"
                                        name="duns_number"
                                        id="duns_number_id"
                                        class="form-control"
                                        maxlength="255"
                                        v-model="duns_number"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Experian ID</td>

                                    <td>
                                      <input
                                        type="text"
                                        name="bin_number"
                                        id="bin_number"
                                        class="form-control"
                                        maxlength="255"
                                        v-model="bin_number"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-12">
                    <div class="card h-100">
                      <div class="card-body">
                        <h4 class="card-title">Corporate Profile</h4>
                        <p></p>
                        <div class="row">
                          <div class="col-lg-6 mb-3">
                            <div class="table-responsive">
                              <table
                                class="
                                  table
                                  align-middle
                                  table-striped table-nowrap
                                  mb-0
                                "
                              >
                                <tbody>
                                  <tr>
                                    <td>Legal Entity Name</td>
                                    <td>
                                      <input
                                        type="text"
                                        name="name"
                                        id="name_id"
                                        class="form-control"
                                        maxlength="255"
                                        v-model.trim="$v.name.$model"
                                        required=""
                                      />
                                      <div
                                        v-if="submitted && !$v.name.required"
                                        class="invalid-tooltip"
                                      >
                                        This field is required
                                      </div>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Address</td>

                                    <td>
                                      <input
                                        type="text"
                                        name="address_street"
                                        id="address_street_id"
                                        class="form-control"
                                        maxlength="255"
                                        v-model="address_street"
                                      />
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>City</td>

                                    <td>
                                      <input
                                        type="text"
                                        name="city"
                                        id="city_id"
                                        class="form-control"
                                        maxlength="255"
                                        v-model="city"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>State</td>

                                    <td>
                                      <v-select
                                        v-model.trim="$v.state.$model"
                                        :options="options"
                                      ></v-select>
                                      <div
                                        v-if="submitted && !$v.state.required"
                                        class="invalid-tooltip"
                                      >
                                        This field is required
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Zip Code</td>

                                    <td>
                                      <input
                                        type="text"
                                        name="zip_code"
                                        id="zip_code_id"
                                        class="form-control"
                                        maxlength="10"
                                        v-model="zip_code"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Phone</td>

                                    <td>
                                      <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        v-model.trim="$v.phone.$model"
                                        class="form-control"
                                        placeholder="999-999-9999"
                                        v-mask="'###-###-####'"
                                      />
                                      <div
                                        v-if="
                                          submitted &&
                                          !$v.phone.customPhoneValidate
                                        "
                                        class="invalid-tooltip"
                                      >
                                        You should provide a phone number
                                        (###-###-####)
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Email</td>

                                    <td>
                                      <input
                                        type="email"
                                        name="email"
                                        id="email_id"
                                        class="form-control"
                                        v-model.trim="$v.email.$model"
                                      />
                                      <div
                                        v-if="submitted && !$v.email.email"
                                        class="invalid-tooltip"
                                      >
                                        You should provide a valid email.
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div class="col-lg-6 mb-3">
                            <table
                              class="
                                table
                                align-middle
                                table-striped table-nowrap
                                mb-0
                              "
                            >
                              <tbody>
                                <tr>
                                  <td>Last Verification Date</td>
                                  <td>
                                    <input
                                      type="date"
                                      name="last_verify_date"
                                      id="last_verify_date"
                                      class="form-control"
                                      v-model="last_verification_date"
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>State of Incorporation</td>

                                  <td>
                                    <input
                                      type="number"
                                      name="state_of_incorporation"
                                      id="state_of_incorporation"
                                      class="form-control"
                                      v-model="state_of_incorporation"
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>Founding Year</td>

                                  <td>
                                    <input
                                      type="number"
                                      name="founding_year"
                                      id="founding_year"
                                      class="form-control"
                                      v-model="founding_year"
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>Type</td>

                                  <td>
                                    <input
                                      type="text"
                                      name="type_id"
                                      id="type_id"
                                      class="form-control"
                                      v-model="type"
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>Structure</td>

                                  <td>
                                    <input
                                      type="text"
                                      name="structure"
                                      id="structure"
                                      class="form-control"
                                      v-model="structure"
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>MPG ID</td>
                                  <td>
                                    <input
                                      type="text"
                                      name="mpg_internal_id"
                                      id="mpg_internal_id"
                                      class="form-control"
                                      maxlength="255"
                                      v-model="mpg_internal_id"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Web</td>
                                  <td>
                                    <input
                                      type="url"
                                      name="web_page"
                                      id="web_page_id"
                                      class="form-control"
                                      v-model.trim="$v.web_page.$model"
                                    />
                                    <div
                                      v-if="submitted && !$v.web_page.url"
                                      class="invalid-tooltip"
                                    >
                                      You should provide a valid URL.
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p></p>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
                <p></p>
              </div>
              <p></p>

              <!-- Start Button -->
              <div class="d-flex flex-wrap gap-2">
                <button
                  class="btn btn-success"
                  :disabled="loadingAction"
                  type="submit"
                >
                  Save
                </button>
                <button
                  @click="$router.go(-1)"
                  type="button"
                  class="btn btn-light waves-effect"
                >
                  Cancel
                </button>
              </div>
              <!-- End Button -->
            </form>
            <!-- End Form -->
          </div>
          <!-- End Card Body -->
        </div>
        <!-- End Card -->
      </div>
      <!-- End Col -->
    </div>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import VueTagsInput from '@johmun/vue-tags-input'
import { required, url, email } from 'vuelidate/lib/validators'
import { router } from '../router'
import { utilService } from '../services/util.service'
import { customPhoneValidate, toBase64 } from '../helpers'
import moment from 'moment'

export default {
  name: 'AddOrganizations',
  components: { VueTagsInput },
  data () {
    return {
      state: '',
      name: '',
      dba: '',
      tokenized_name: [],
      zoominfo_id: '',
      tax_id: '',
      duns_number: '',
      bin_number: '',
      web_page: '',
      email: '',
      phone: '',
      linkedin: '',
      contact_source: '',
      submitted: false,
      loading: true,
      error: '',
      city: '',
      type: '',
      zip_code: '',
      address_street: '',
      last_verification_date: '',
      state_of_incorporation: '',
      primary_industry: '',
      naics: '',
      naics1: '',
      naics2: '',
      naics3: '',
      age: '',
      number_of_locations: '',
      estimated_revenue: '',
      estimated_emplpoyee_count: '',
      mpg_internal_id: '',
      fein_number: '',
      structure: '',
      founding_year: '',
      options: [],
      facebook: '',
      twitter: '',
      glassdoor: '',
      url: '',
      isEdit: false,
      loadingAction: false
    }
  },
  validations: {
    state: { required },
    name: { required },
    web_page: { url },
    linkedin: { url },
    facebook: { url },
    twitter: { url },
    glassdoor: { url },
    email: { email },
    phone: { customPhoneValidate }
  },
  computed: {},
  created () {
    if (this.$route.params.id && this.$route.params.id !== '') {
      this.isEdit = true
    }

    utilService.getState().then((rs) => {
      this.options = rs.results.map((e) => {
        e.label = e.acronym
        e.code = e.state_id
        return e
      })

      if (this.isEdit) {
        this.loading = true
        organizationsService.getDataById(this.$route.params.id).then((rs) => {
          if (rs.addresses.length > 0) {
            this.state = this.options.find(
              (e) => e.acronym === rs.addresses[0].state.acronym
            )
            this.city = rs.addresses[0].city
            this.zip_code = rs.addresses[0].zip_code
            this.address_street = rs.addresses[0].address_street
          }
          this.zoominfo_id = rs.zoominfo_id
          this.type = rs.type
          this.name = rs.name
          this.dba = rs.dba
          this.tax_id = rs.tax_id
          this.duns_number = rs.duns_number
          this.bin_number = rs.bin_number
          this.web_page = rs.web_page
          this.email = rs.email
          this.phone = rs.phone
          this.linkedin = rs.linkedin
          this.contact_source = rs.contact_source
          if (rs.last_verification_date) {
            this.last_verification_date = moment(
              rs.last_verification_date
            ).format('YYYY-MM-DD')
          }
          this.state_of_incorporation = rs.state_of_incorporation
          this.primary_industry = rs.primary_industry
          if (rs.naics) {
            this.naics = rs.naics[0]
            this.naics1 = rs.naics[1]
            this.naics2 = rs.naics[2]
            this.naics3 = rs.naics[3]
          }
          this.number_of_locations = rs.number_of_locations
          this.estimated_revenue = rs.estimated_revenue
          this.estimated_emplpoyee_count = rs.estimated_emplpoyee_count
          this.mpg_internal_id = rs.mpg_internal_id
          this.fein_number = rs.fein_number
          this.structure = rs.structure
          this.founding_year = rs.founding_year
          this.glassdoor = rs.glassdoor
          this.twitter = rs.twitter
          this.facebook = rs.facebook
          this.url = rs.logo
          this.loading = false
        })
      } else {
        this.loading = false
      }
    })
  },
  methods: {
    moment,
    onFileChange (e) {
      const file = e.target.files[0]
      this.url = URL.createObjectURL(file)
    },
    async onSubmit () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      //
      // this.loading = true
      let date = this.last_verification_date
      if (date) {
        date = new Date(date).toISOString()
      }

      const payload = {
        type: this.type,
        state: this.state.code,
        name: this.name,
        tax_id: this.tax_id,
        duns_number: this.duns_number,
        bin_number: this.bin_number,
        web_page: this.web_page,
        email: this.email,
        phone: this.phone,
        linkedin: this.linkedin,
        contact_source: this.contact_source,
        city: this.city,
        zip_code: this.zip_code,
        address_street: this.address_street,
        state_of_incorporation: this.state_of_incorporation,
        primary_industry: this.primary_industry,
        naics: [this.naics, this.naics1, this.naics2, this.naics3],
        number_of_locations: this.number_of_locations,
        estimated_revenue: this.estimated_revenue,
        estimated_emplpoyee_count: this.estimated_emplpoyee_count,
        mpg_internal_id: this.mpg_internal_id,
        fein_number: this.fein_number,
        structure: this.structure,
        founding_year: this.founding_year,
        glassdoor: this.glassdoor,
        twitter: this.twitter,
        facebook: this.facebook
      }

      if (date && date !== '') {
        payload.last_verification_date = date
      }

      const _file = this.$refs.file.files[0]

      if (_file) {
        const base64 = await toBase64(_file)
        payload.logo = base64
      } else {
        // if (!this.url || this.url === '') {
        //   this.$bvToast.toast('Logo fields required.', {
        //     title: `Validation`,
        //     variant: 'danger'
        //   })
        //   return
        // }
        // payload.logo = this.url
      }
      this.loadingAction = true
      if (this.isEdit) {
        organizationsService.update(payload, this.$route.params.id).then(
          (rs) => {
            this.loadingAction = false
            this.$bvToast.toast('Update successfully.', {
              title: `Update`,
              variant: 'primary',
              solid: true
            })
            router.push(
              '/mpg/organizations/' + this.$route.params.id + '/details'
            )
          },
          (error) => {
            this.error = error
            this.loadingAction = false
          }
        )
      } else {
        organizationsService.add(payload).then(
          (rs) => {
            this.$nextTick(() => {
              router.push(
                '/mpg/organizations/' + rs.organization_id + '/details'
              )
            })
          },
          (error) => {
            this.$bvToast.toast('Cannot Update Organization.', {
              title: `Update`,
              variant: 'danger',
              solid: true
            })
            this.error = error
            this.loadingAction = false
          }
        )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AddOrganizations.vue